var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code-guide"},[_c('div',{staticClass:"hd"},[_vm._v("访问移动端直播间，可参与更多互动。")]),_c('div',{staticClass:"bd"},[_c('div',{staticClass:"qr-code",attrs:{"id":_vm.qrcodeId}})])])}
var staticRenderFns = []

export { render, staticRenderFns }